import styled from "styled-components";

export const FilesList = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: 98%;
`;

export const FileInfo = styled.div`
  align-items: center;
  border-color: transparent;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 5px 20px rgb(231 231 234 / 62%);
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 0 1rem;

  div {
    align-items: center;
    display: grid;
    gap: 1.3rem;
    grid-template-columns: 1.5rem 40rem 6rem;
  }

  .delete-icon {
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(106deg) brightness(30%)
      contrast(105%);
  }

  p {
    margin-left: 1rem;
  }

  .size {
    color: ${(props) => props.theme.colors.gray72};
    font-weight: 500;
  }
`;

interface IRowContainer {
  height?: string;
  width?: string;
}
export const RowContainer = styled.div<IRowContainer>`
  border-radius: 8px;
  border: 1px dashed #002e6c;
  cursor: pointer;
  height: ${(props) => (props.height ? props.height : "auto")};
  margin-top: 1.5rem;
  width: ${(props) => (props.width ? props.width : "55rem")};
  p {
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
    font-weight: 500;
  }

  img {
    padding: 0.5rem;
  }
`;

export const DashedRow = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextTitle};
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.2rem;
  font-weight: 500;
  padding: 3rem 0;
  row-gap: 0.8rem;
  text-align: center;
`;

export const DashedReducedRow = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextTitle};
  display: flex;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.2rem;
  font-weight: 500;
  justify-content: center;
  padding: 0.15rem 0;
`;
